import React, {useEffect, useState, useRef, Fragment} from 'react';
import ReactDOM from 'react-dom';
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Sales_coach_display from '../../SalesCoach/display.js'
import axios from 'axios';
import {connect} from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  iconButton:{
    left:(props)=>(props.bigWebsite==true)?'calc(66vw - 25px)':'calc(33vw - 30px)',
    zIndex:'10000',
    display:'flex',
    ['@media(max-width:600px)']:{
      display:'none',
      zIndex:'10000000000',
      left:'0px'
    },
  }
}));





function Iframes(props){
    console.log('REFRESH IFRAMES');
    let classes=useStyles(props);
    const [sales_coach_display, setSalesCoachDisplay]=useState(false);
    //Company only set for sales coach;
    const [company, setCompany]=useState(undefined);
    const [sales_coach_deal, setSalesCoachDeal]=useState(false);
    const [force_on, setForceOn]=useState(false);
    const [url, setUrlInner]=useState();
    let url_object=useRef();

    function setUrl(x){setUrlInner(x); url_object.current=x;}

    const [only_url_no_iframe_data, setOnlyUrlNoIframeData]=useState(false);
    let survey=useRef(false);
    let change_filter_search=useRef('');
    let dataIndex=props.current_list.current_index - ((props.current_list.start_page - 1) * props.current_list.rowsPerPage);

    function setDataIndex(n){let url=window.location.pathname; let parts=url.split('/view/'); let start=parts[0]+'/view/'; let end=''; let i=0; for(let p of parts[1].split('/')){if(i>0){end+='/'+p;} i+=1;} url=start+(n+1)+end; props.history.push(url);}
    const [refresh, setRefresh]=useState(0);
    let requested_iframe_data=useRef({});
    let data=useRef();

    let current_filter_search=JSON.stringify({query:props.current_list.query, filter:props.current_list.filter});  if(change_filter_search.current!=current_filter_search){requested_iframe_data.current={}; change_filter_search.current=current_filter_search;}

    useEffect(()=>{
      props.setFunctions(iframeSwitch, setExtraUrl, updateData, initSalesCoach);
    },[]);

    function iframeSwitch(index){setOnlyUrlNoIframeData(false); setForceOn(undefined); setUrl(undefined); setDataIndex(index); setSalesCoachDisplay(false);}
    function updateData(d, refresh_iframes){console.log(d, 'DDDD'); data.current=undefined; data.current=JSON.parse(JSON.stringify(d)); if(refresh_iframes==true){setRefresh(0); setRefresh(1);}}

    function initSalesCoach(company, deal=undefined){
    if(deal==undefined && sales_coach_deal!=undefined){
      setSalesCoachDisplay(false);
      setSalesCoachDeal(undefined);
      setCompany(undefined);
    }else{
      setSalesCoachDisplay(false);
      setSalesCoachDeal(undefined);
      setCompany(undefined);
      setSalesCoachDisplay(true);
      setSalesCoachDeal(deal);
      setCompany(company);
    }}


    function iframeOrOpen(url, iframe_url, big_website, dataIndex, o_window){//let main_iframe=document.getElementById('main_iframe');
      let win;
      console.log(url, iframe_url, url==url_object.current, 'COOL');
      if(iframe_url==undefined || url==url_object.current){
        win = openWindow(url, big_website, data.current[dataIndex], o_window);
        win.focus();
      }

      if(iframe_url!=undefined){

        console.log("IFRAME URL X", iframe_url);
        setUrl(iframe_url); //This sets the url for the iframe;
        setForceOn(true); //This forces the iframe to display (and to refresh?);
        setOnlyUrlNoIframeData(true);  //This makes sure url isn't checked for iframe data because it already has been.
        setSalesCoachDisplay(false);
        
        url_object.current=url;
      }
      return win;
    }


    function setExtraUrl(big_website, type, url, o_window, dataIndex=undefined, force_popup=false, extra_data={}){
      console.log(props, type, url, dataIndex, 'WOW_WOW');
      url=url.replace('https://', '').replace('http://', '').replace('//','');
      survey.current=false; setForceOn(false); setOnlyUrlNoIframeData(false); //setSalesCoachDisplay(false);
      let iframe_url=undefined;
      let company_url_type=undefined;
      for(let cut of props.company_url_types){if((extra_data.company_url_type_id!=undefined && extra_data.company_url_type_id==cut.id) || cut.domain==type){company_url_type=cut;}}
      if(dataIndex==undefined || data.current==undefined || data.current[dataIndex]==undefined){return(null);}
      if(url.includes('google.com')){}
      else if((company_url_type!=undefined && company_url_type.allows_iframe=='ALWAYS') || ['admin_json', 'generic_link', 'website', 'survey'].includes(type) || type.includes('listing_website_')){
        iframe_url=url; if(type=='survey'){survey.current=url;}
      }else if(type=='facebook'){
        iframe_url=url.replace(':','%3A').replace('//', '%2F%2F').replace('/', '%2F');
        iframe_url="www.facebook.com/plugins/page.php?href="+iframe_url+"&tabs=timeline&width=500&height=1000&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId";
      }else if(type=='youtube' && (url.includes('www.youtube.com/channel/') || url.includes('www.youtube.com/user/') || url.includes('www.youtube.com/c/') || url.includes('www.youtube.com/embed/') || url.includes('?watch=') || url.includes('?embed='))){
        let link=url.replace('www.youtube.com/', ''); let array=link.split('/');
        if(array[0]=='user'){iframe_url='www.youtube.com/embed?listType=user_uploads&list='+array[1];}else if(array[0]=='channel' || array[0]=='c'){iframe_url=undefined;}else if(array[0]=='embed'){iframe_url=url;}
        else{array=link.split('?'); if(array[0]=='embed'){iframe_url=url;}else if(array[0]=='watch'){let na=array[1].split('&'); let vid_id=na[0].replace('v=',''); iframe_url='www.youtube.com/embed/'+vid_id;}}
      }
      let http='https://';
      if(type=='website' && data.current[dataIndex].iframe_data!=undefined){
        if(data.current[dataIndex].iframe_data.with_www==true){url='www.'+url; iframe_url='www.'+iframe_url;}
        if(data.current[dataIndex].iframe_data.ssl_available==false){http='http://';}
        if(data.current[dataIndex].iframe_data.works_in_iframe==false && data.current[dataIndex].iframe_data.no_website==false){iframe_url='https://proxy.talcap.net/?q='+btoa(http+iframe_url);}
      }
      return iframeOrOpen(http+url, (iframe_url==undefined || force_popup==true)?undefined:(iframe_url.includes('https://proxy.talcap.net/?q='))?iframe_url:(http+iframe_url), big_website, dataIndex, o_window);
    }

    function getFirstUrl(d){
      if(d.company_listing_websites!=undefined && d.company_listing_websites[0]!=undefined){return d.company_listing_websites[0].website;}
    }

    if(dataIndex==undefined || data.current==undefined || data.current[dataIndex]==undefined){return(null);}

    console.log(data.current, 'DATA CURRENT');
  console.log("IFRAME URL X", sales_coach_display);
    return(
      <div>
        {(data.current==undefined)?null:data.current.map((d, index)=>{
          if(d==null || d==undefined){return null;}
          let urll='https://'+d.website;
          if(d.website==undefined){
            getFirstUrl(d);
          }
          if(data.current[dataIndex].id==d.id && url!=undefined){
            urll=url;}


          if(only_url_no_iframe_data!=true){
            if(d.website!=null && d.website.includes('facebook.com')){
              urll=d.website.replace(':','%3A').replace('//', '%2F%2F').replace('/', '%2F');
              urll="https://www.facebook.com/plugins/page.php?href="+urll+"&tabs=timeline&width=500&height=1000&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
            }else{
              if((d.website!=undefined && index>=(dataIndex-3) && index<=(dataIndex+6)) && data.current[index].iframe_data==undefined && requested_iframe_data.current[index]==undefined){
                requested_iframe_data.current[index]=true;
                fetch('/api/domains/'+data.current[index].domain_id+'?check_url='+urll)
                .then(response => response.json())
                .then(d => {data.current[index]={...data.current[index], ...d}; props.setIframeData(data.current[index].id, d.iframe_data, d.links, d.back_links, d.last_scraped); setRefresh(0); setRefresh(1);});
              }
              if(data.current[index].iframe_data!=undefined && data.current[index].iframe_data.with_www==true){urll=urll.replace(d.website, 'www.'+d.website);}
              if(data.current[index].iframe_data==undefined){if(data.current[dataIndex].website!=undefined){urll=undefined;}}else if(data.current[index].iframe_data.works_in_iframe==false && data.current[index].iframe_data.no_website==false){
                //if(data.current[index].iframe_data.ssl_available==false){urll=urll.replace('https://', 'http://');}
                urll='https://proxy.talcap.net/?q='+btoa(urll);}
            }
          }
          if(data.current[dataIndex].id==d.id){url_object.current=urll;}

          return(
            <Fragment>
              {(sales_coach_display==true && data.current[dataIndex].id==d.id)?<div style={{overflowX:'hidden', position:'absolute', top:'0px', left:'0px', width:'100%', backgroundColor:'white', height:'100%', zIndex:(data.current[dataIndex]!=undefined && data.current[dataIndex].id==d.id)?'1000000':'0',  display:'flex', justifyContent:'center', alignItems:'center'}}><Sales_coach_display {...props} deal={sales_coach_deal} setSalesCoachDisplayOff={()=>{setSalesCoachDisplay(false);setSalesCoachDeal(undefined);setCompany(undefined);}} company={company}/></div>:null}
              {(force_on==true || (urll!=undefined && d.website!=undefined && index>=(dataIndex-3) && index<=(dataIndex+6) && props.current_list_block!=true))?
              <iframe frameBorder='0' id={(data.current[dataIndex] && data.current[dataIndex].id==d.id)?'main_iframe':undefined} style={{position:'absolute', backgroundColor:'white', top:'0px', left:'0px', width:'100%', height:'100%', zIndex:(data.current[dataIndex]!=undefined && data.current[dataIndex].id==d.id && sales_coach_display!=true)?'1000000':'0'}} src={urll} title={d.name} sandbox="allow-scripts allow-same-origin allow-forms"></iframe>
              :
              <div style={{overflowX:'hidden', position:'absolute', top:'0px', left:'0px', width:'100%', backgroundColor:'white', height:'100%', zIndex:(data.current[dataIndex]!=undefined && data.current[dataIndex].id==d.id && sales_coach_display!=true)?'1000000':'0',  display:'flex', justifyContent:'center', alignItems:'center'}}>No Website</div>
              }
            </Fragment>
           );
        })}
        <div style={{height:'100vh', justifyContent:'center', alignItems:'center', position:'absolute'}} className={classes.iconButton}><IconButton color='primary' style={{backgroundColor:'#3f51b5'}} onClick={()=>{if(props.bigWebsite==false){props.setNavigationWidth('34vw')}else{props.setNavigationWidth('67vw')} props.setBigWebsite(!props.bigWebsite)}}>{(props.bigWebsite)?<ArrowBackIosIcon style={{marginLeft:'35px', marginRight:'-15px', color:'white'}}/>:<ArrowForwardIosIcon style={{marginLeft:'25px', marginRight:'-5px', color:'white'}}/>}</IconButton></div>
      </div>
    )
}


export default connect(ss, dd)(Iframes);

function ss(state){return {
  current_list_index:state.companies.current_list.current_index,
  current_list_block:state.companies.current_list.block_iframe
}}

function dd(dispatch){
   return {
     setIframeData:(id, iframe_data, links, back_links, last_scraped)=>{dispatch({type:'REQUEST_IFRAME_DATA_SUCCESS', id:id, iframe_data:iframe_data, links:links, back_links:back_links, last_scraped:last_scraped});}
   }
}



export function openWindow(url, big_website, company, o_window){
    let width=window.innerWidth;
    if(big_website==true){width=(width/3)*2}
    else{width=width/3}
    let height=window.outerHeight;
    url=url.replace('https://https://', 'https://')
    if(o_window!=undefined && o_window!=null){
      o_window.close();
      //o_window.location.href=url; return o_window;
    }
    let win=window.open(url, 'prospector_popup_'+company.id, 'height='+height+', width='+window.screenX+', top='+window.screenY+', left=0');
    //let json=document.getElementById('prospector_popup').innerText; if(json='.'){json={}}else{json=JSON.parse(json);}
    //if(url[url.length-1]!='/'){url=url+'/';}
    //json[url]=company.id;
    //json=JSON.stringify(json);
    //document.getElementById('prospector_popup').innerText=json;
    return win;
}
